import { lazyWithSuspense } from '~/utilities/lazyWithSuspense';

export const GroupRecordTrialScreen = lazyWithSuspense(async () => import('./GroupRecordTrial'), {
  loadingState: <div />,
  exportKey: 'GroupRecordTrial',
});
